module.exports = __webpack_public_path__ + "2ff5d0bf81b5d353f79a7f4def50cdd5.svg";